import React from 'react'
import {
    Grid,
    Skeleton,
    Theme,
} from '@mui/material';

/**
 * Loader for report card information
 * @constructor
 * @todo Rework to use Card components from ui-kit
 */
const InfoCardLoader = () => (
    <Grid container sx={(theme: Theme) => ({
        marginBottom: theme.spacing(2),
        boxShadow: '0px 1px 3px 0px #0000001F',
        borderRadius: theme.spacing(2),
        padding: theme.spacing(2),
        backgroundColor: '#F5F5F5',
        overflow: 'auto',
        wordWrap: 'break-word',
        [theme.breakpoints.up('sm')]: {
            overflow: 'hidden',
        },
        position: 'relative',
    })}>
        {
            Array.from(Array(1).keys()).map((_, index) => (
                <Grid container spacing={1} key={index}>
                    {Array.from(Array(6).keys()).map((item) => (
                        <Grid item xs={6} sm={4} md={2} key={item}>
                            <Skeleton height={60} />
                        </Grid>
                    ))}
                </Grid>
            ))
        }
    </Grid>
)

export default InfoCardLoader
